
<template>
    <router-link  
        class="back-link"
        :to="backLink + workspaceId"
        :style="{
            color: colors.secondary
        }"
    >	
        <div class="arrow-left"
            :style="{
                'border-right': `6px solid ${colors.secondary}`
            }"
        ></div>
        <span>{{ $t("components.InputDefault.backOption") }}</span>  
    </router-link>
</template>

<script>
/* eslint-disable */
export default {
    created(){
         this.colors = JSON.parse(localStorage.getItem("colors"))
         this.backLink = "/logout?workspaceId="
         this.workspaceId = localStorage.getItem("workspaceId")
    }
}
</script>

<style lang="scss" scoped>
.back-link{
    height: 2vh;
    max-width: 65px;
    display: flex;
    text-decoration: none;
    margin: 32px;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 2px;
    font-size: 12px;
    align-items: center;    
    .arrow-left {
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-right: 6px solid #fff;
        width: 0;
        position: relative;
        right: 10px;
      } 
}
</style>